import React, { useState, useEffect } from 'react';
import API from '../../../pages/Api';
import { toast } from 'react-toastify';
import { FaTrash, FaEdit, FaPlus } from 'react-icons/fa';
import TableContainer from '../../common/Tablecontainer';

const AddvideoStudyMaterial = () => {
  const [list, setList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showVideoModal, setShowVideoModal] = useState(false); // Modal for secure video playback
  const [videoUrl, setVideoUrl] = useState(null);
  const [courses, setCourses] = useState([]);
  const [materialTypes, setMaterialTypes] = useState([]); 
  const [isEditing, setIsEditing] = useState(false);
  const [currentDtlsId, setCurrentDtlsId] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  
  // Form State
  const [selectedCourse, setSelectedCourse] = useState('');
  const [materialType, setMaterialType] = useState('');
  const [attachments, setAttachments] = useState([]);
  const [mobilePage, setMobilePage] = useState(1);
  const cardsPerPage = 5;

  useEffect(() => {
    fetchMainList();
    fetchCourses();
    fetchMaterialTypes();
  }, []);

  const fetchMainList = async () => {
    try {
      const res = await API.get('getAllVideoAndStudyList/');
      setList(res.data);
    } catch (err) { console.error("Error fetching list", err); }
  };

  const fetchCourses = async () => {
    try {
      const res = await API.get('getAllAmounts/');
      setCourses(res.data);
    } catch (err) { console.error("Error fetching courses", err); }
  };

  const fetchMaterialTypes = async () => {
    try {
      const res = await API.get('material-type/'); 

      setMaterialTypes(res.data);
    } catch (err) {
      setMaterialTypes([
        { materialName: "Video", materialId: "1" },
        { materialName: "Study Material", materialId: "2" }
      ]);
    }
  };

  const addRow = () => {
    setAttachments([...attachments, { filedescription: '', studyType: 'Document', file: null, existingFileName: '', Link: '' }]);
  };

  const removeRow = (index) => {
    setAttachments(attachments.filter((_, i) => i !== index));
  };

  const handleEdit = (item) => {
    setIsEditing(true);
    setCurrentDtlsId(item.dtlsId);
    setSelectedCourse(item.CourseId);
    setMaterialType(item.materialId);
    
    if (item.attachmentData && item.attachmentData.length > 0) {
        const existing = item.attachmentData.map(att => {
            
            return {
                filedescription: att.filedescription || att.description || '',
                studyType: att.studytype || att.studyType || 'Document',
                file: null,
                existingFileName: att.attachmentname || att.attachmentName || att.file || '',
                id: att.fileattachmentid || att.FileAttachmentId || null,
                Link: att.link || att.Link || ''
            };
        });
        setAttachments(existing);
    } else {
        setAttachments([]);
    }
    setShowModal(true); 
  };
  const handleFileChangeAndUpload = async (
      index,
      selectedFile,
      currentStudyType
  ) => {
      if (!selectedFile) return;

      const imgFormData = new FormData();
      imgFormData.append('image', selectedFile);

      try {
          const res = await API.post(
              'email/upload_image/',
              imgFormData,
              {
                  headers: {
                      'Content-Type': 'multipart/form-data'
                  }
              }
          );

          if (res.data && res.data.file_url) {
              setAttachments((prev) =>
                  prev.map((item, i) =>
                      i === index
                          ? {
                                ...item,
                                existingFileName:
                                    res.data.file_url
                            }
                          : item
                  )
              );

             toast.success("File Uploaded Successfully!");
          }
      } catch (err) {
         toast.error("File upload failed.");
      }
  };

  const openSavedFileSecurely = (fileNameString) => {
    if (!fileNameString) return;
    
    let cleanUrl = String(fileNameString).trim();
    const backendBase = process.env.REACT_APP_BACKEND_URL || 'http://103.172.92.148:8005';
    console.log(fileNameString);
    
    // Check for video format to play securely
   if (
    cleanUrl.endsWith('.mp4') ||
    cleanUrl.endsWith('.mkv') ||
    cleanUrl.endsWith('.avi')
) {
    let finalFileUrl = '';

    // already contains /media/Videos/
    if (cleanUrl.includes('/media/')) {
        finalFileUrl = cleanUrl.startsWith('http')
            ? cleanUrl
            : `${backendBase}${cleanUrl}`;
    } else {
        // only filename returned
        finalFileUrl = `${backendBase}/media/Videos/${cleanUrl}`;
    }

    setVideoUrl(finalFileUrl);

    console.log(finalFileUrl);

    setShowVideoModal(true);
}
    else if (cleanUrl.startsWith('http://') || cleanUrl.startsWith('https://')) {
        window.open(cleanUrl, '_blank');
    } else {
        const formattedPath = cleanUrl.startsWith('/') ? cleanUrl : `/${cleanUrl}`;
        window.open(`${backendBase}${formattedPath}`, '_blank');
    }
  };

  const handleSave = async () => {

      if (!selectedCourse || !materialType) {
          toast.warn("Please select Course and Material Type");
          return;
      }

      const formData = new FormData();

      formData.append('CourseId', selectedCourse);
      formData.append('materialId', materialType);

      if (isEditing && currentDtlsId) {
          formData.append('dtlsId', currentDtlsId);
      }

      formData.append(
          'totAttachment',
          attachments.length
      );

      attachments.forEach((item, index) => {

          formData.append(
              `attachmentData[${index}][filedescription]`,
              item.filedescription || ''
          );

          formData.append(
              `attachmentData[${index}][studyType]`,
              item.studyType || 'Document'
          );

          formData.append(
              `attachmentData[${index}][link]`,
              item.Link || ''
          );

          formData.append(
              `attachmentData[${index}][existingFileName]`,
              item.existingFileName || ''
          );

      });

      console.log([...formData.entries()]);

      try {

          const url = isEditing
              ? 'UpdateVideoStudyDetails/'
              : 'SaveVideoStudyDetails/';

          const res = await API.post(
              url,
              formData
          );

          if (
              res.data &&
              (
                  res.data.includes("OK") ||
                  res.data[0] === "OK"
              )
          ) {

              toast.success(
                  isEditing
                      ? "Updated Successfully!"
                      : "Saved Successfully!"
              );

              handleCloseModal();

              fetchMainList();

              if (window.activeRefreshTrigger) window.activeRefreshTrigger();
          }

      } catch (err) {

          console.error(
              "Error saving layout data:",
              err
          );

          toast.error("Error saving study details.");
      }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setIsEditing(false);
    setSelectedCourse('');
    setMaterialType('');
    setAttachments([]);
    setCurrentDtlsId(null);
  };

  const handleDelete = async (dtlsId) => {
      if (window.confirm("Are you sure you want to delete this record?")) {
        try {
          await API.delete(`DeleteVideoStudy/${dtlsId}/`);
          toast.error("Deleted Successfully!");
          fetchMainList(); 
        } catch (err) {
          console.error("Error deleting record:", err);
        }
      }
    };
    const getYoutubeEmbedUrl = (url) => {
      if (!url) return '';

      // youtu.be
      if (url.includes('youtu.be/')) {
          const id = url.split('youtu.be/')[1]?.split('?')[0];
          return `https://www.youtube.com/embed/${id}`;
      }

      // youtube watch
      if (url.includes('watch?v=')) {
          const id = url.split('watch?v=')[1]?.split('&')[0];
          return `https://www.youtube.com/embed/${id}`;
      }

      return url;
  };
    const filteredList = list.filter((item) => {
        const q = searchQuery.toLowerCase();

        return (
            item.AmtDesc?.toLowerCase().includes(q) ||
            item.materialName?.toLowerCase().includes(q)
        );
    });

    const paginatedList = filteredList.slice(
        (mobilePage - 1) * cardsPerPage,
        mobilePage * cardsPerPage
    );

  return (
    <div className="bg-gray-100 min-h-screen font-sans p-3 sm:p-5 md:p-6">
      <h2 className="text-center text-xl sm:text-2xl md:text-3xl font-light text-gray-700 mb-6 sm:mb-8 tracking-tight">Add Video And Study Material</h2>
      
      <div className="max-w-7xl mx-auto bg-white shadow-md rounded border border-gray-200">
        <div className="p-3 border-b flex justify-center sm:justify-end bg-gray-50">
          <button onClick={() => { setIsEditing(false); setAttachments([{ filedescription: '', studyType: 'Document', file: null, existingFileName: '', Link: '' }]); setShowModal(true); }} className="w-full sm:w-auto bg-blue-900 border border-blue-900 text-white px-5 py-1.5 rounded-sm text-sm font-semibold  transition-all">+ Add New Material</button>
        </div>
        <div className="hidden md:block">
        <TableContainer
          columns={['COURSE DESCRIPTION', 'MATERIAL TYPE', 'EDIT', 'DELETE']}
          apiUrl="getAllVideoAndStudyList/"
          data={list} // Safe fallback binding array mapping logic cleanly
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          searchPlaceholder="Search material by course name..."
          renderRow={(item, index, srNo, formatCurrency, refreshTable) => (
            <tr key={item.dtlsId || index} className="text-[13px] border-b hover:bg-blue-50/40 text-center transition-colors">
              <td className="py-3 px-2 border-r bg-gray-50/30 font-bold text-gray-400 w-[8%] text-center">{srNo}</td>
              <td className="py-4 px-6 border-r font-bold text-gray-700 text-left uppercase">{item.AmtDesc}</td>
              <td className="py-4 px-6 border-r text-left font-semibold text-[#032167]">{item.materialName}</td>
              <td className="py-4 px-4 border-r text-center w-24">
                <button type="button" onClick={() => handleEdit(item, refreshTable)} className="text-[#64a106] hover:text-green-800 transition-all border-none bg-transparent cursor-pointer">
                    <FaEdit size={18} />
                </button>
              </td>
              <td className="py-4 px-4 text-center w-24">
                <button type="button" onClick={() => handleDelete(item.dtlsId, refreshTable)} className="text-gray-400 hover:text-red-600 transition-all border-none bg-transparent cursor-pointer">
                    <FaTrash size={16} />
                </button>
              </td>
            </tr>
          )}
        />
        </div>
        <div className="md:hidden space-y-4">
        <div className="mb-4">

            <input
                type="text"
                value={searchQuery}
                placeholder="Search Material..."
                onChange={(e) => {
                    setSearchQuery(e.target.value);
                    setMobilePage(1);
                }}
                className="w-full border rounded-lg p-3 text-sm outline-none"
            />

        </div>
        {paginatedList.map((item)=>(
        <div
        key={item.dtlsId}
        className="bg-white rounded-xl shadow border p-4">

        <div className="space-y-3">

        <div>

        <p className="text-xs text-gray-500">
        Course
        </p>

        <p className="font-bold text-[#032167]">
        {item.AmtDesc}
        </p>

        </div>

        <div className="flex justify-between">

        <div>

        <p className="text-xs text-gray-500">
        Material
        </p>

        <p className="font-semibold">
        {item.materialName}
        </p>

        </div>

        </div>

        <div className="flex justify-end gap-3 pt-2 border-t">

        <button
        onClick={()=>handleEdit(item)}
        className="text-green-600">

        <FaEdit/>

        </button>

        <button
        onClick={()=>handleDelete(item.dtlsId)}
        className="text-red-600">

        <FaTrash/>

        </button>

        </div>

        </div>

        </div>

        ))}

        </div>
        
      </div>
      <div className="flex justify-between items-center mt-5">

        <button
            disabled={mobilePage === 1}
            onClick={() => setMobilePage((p) => p - 1)}
            className="px-4 py-2 border rounded disabled:opacity-40"
        >
            Previous
        </button>

        <span className="text-sm font-semibold">
            Page {mobilePage} of {Math.ceil(filteredList.length / cardsPerPage)}
        </span>

        <button
            disabled={mobilePage >= Math.ceil(filteredList.length / cardsPerPage)}
            onClick={() => setMobilePage((p) => p + 1)}
            className="px-4 py-2 border rounded disabled:opacity-40"
        >
            Next
        </button>

        </div>

      {/* Secure Video Playback Modal */}
      {showVideoModal && (
        <div className="fixed inset-0 bg-black/95 flex items-center justify-center z-[2000] p-4">
            <button onClick={() => setShowVideoModal(false)} className="absolute top-5 right-10 text-white text-4xl z-50">&times;</button>
            <video 
                controls 
                controlsList="nodownload" 
                onContextMenu={(e) => e.preventDefault()}
                className="w-full max-w-full sm:max-w-4xl rounded-lg shadow-2xl"
            >
                <source src={videoUrl} type="video/mp4" />
            </video>
        </div>
      )}

      {/* Upload Dynamic Modal Form */}
      {showModal && (
        <div className="fixed inset-0 z-[1000] bg-black/60 backdrop-blur-sm overflow-y-auto">

            <div className="flex min-h-full items-center justify-center px-3 pt-20 pb-6 md:p-8">
            <div className="relative flex flex-col w-full max-w-[95vw] sm:max-w-2xl lg:max-w-5xl rounded-xl bg-white shadow-2xl border border-gray-300 max-h-[85vh]">
            <button onClick={handleCloseModal} className="absolute right-3 top-3 text-2xl md:text-3xl text-gray-400 hover:text-black z-10">&times;</button>
            <div className="p-5 sm:p-6 md:p-8 pb-4 flex-shrink-0">
                <div className="flex justify-center mb-6">
                    <span className="font-bold text-xs sm:text-sm uppercase text-center px-2 sm:px-6 border-b-2 border-black pb-1">Add/Edit Study Details</span>
                </div>
                <div className="grid grid-cols-1 gap-4 px-2 sm:px-4 max-w-3xl mx-auto mb-4">
                    <div className="flex flex-col sm:flex-row gap-2 sm:items-center">
                        <label className="w-full sm:w-48 text-[13px] font-bold text-gray-700">Select Course :</label>
                        <select value={selectedCourse} onChange={(e)=>setSelectedCourse(e.target.value)} className="flex-1 p-2 border rounded text-xs bg-gray-50 outline-none">
                            <option value="">-- Select --</option>
                            {courses.map(c => <option key={c.amtId} value={c.amtId}>{c.AmtDesc}</option>)}
                        </select>
                    </div>
                    <div className="flex flex-col sm:flex-row gap-2 sm:items-center">
                        <label className="w-full sm:w-48  text-[13px] font-bold text-gray-700">Material type :</label>
                        <select value={materialType} onChange={(e)=>setMaterialType(e.target.value)} className="flex-1 p-2 border rounded text-xs bg-gray-50 outline-none">
                            <option value="">-- Select --</option>
                            <option value="1">Video</option>
                            <option value="2">Study Material</option>
                        </select>
                    </div>
                </div>
                <div className="px-4 sm:px-6 lg:px-10 max-w-5xl mx-auto">
                    <button onClick={addRow} className="w-full sm:w-auto bg-[#032167] text-white px-4 py-3 rounded text-sm font-bold hover:bg-blue-900 flex justify-center items-center gap-2">
                        <FaPlus className="text-xs" /> Add Attachment
                    </button>
                </div>
            </div>

            <div className="flex-1 overflow-y-auto px-4 sm:px-8 lg:px-16 py-4">
                <div className="hidden md:block">
                <table className="w-full border border-gray-300 text-[11px] border-separate border-spacing-0">
                <thead className="bg-gray-100 sticky top-0 z-10 shadow-xs">
                    <tr>
                        <th className="p-3 border-b border-r border-gray-300 text-center">Description</th>
                        <th className="p-3 border-b border-r border-gray-300 w-36 text-center">Type</th>
                        <th className="p-3 border-b border-r border-gray-300 text-center">Attachment File / External Link</th>
                        <th className="p-3 border-b border-gray-300 w-16 text-center">Delete</th>
                    </tr>
                </thead>
                <tbody className="bg-white">
                    
                    {attachments.map((at, index) => (
                    <tr key={index}>
                        <td className="p-2 border-b border-r border-gray-200">
                            <input type="text" value={at.filedescription} placeholder="Enter file description" className="w-full p-2 border border-gray-200 rounded outline-none font-medium" onChange={(e) => {
                                const newAt = [...attachments];
                                newAt[index].filedescription = e.target.value;
                                setAttachments(newAt);
                            }} />
                        </td>
                        <td className="p-2 border-b border-r border-gray-200">
                            <select value={at.studyType} className="w-full p-1.5 border border-gray-200 rounded bg-white font-medium" onChange={(e) => {
                                const newAt = [...attachments];
                                newAt[index].studyType = e.target.value;
                                setAttachments(newAt);
                            }}>
                                <option value="Document">Document</option>
                                <option value="Image">Image</option>
                                <option value="Video">Video</option>
                                <option value="External Link">External Link</option>
                            </select>
                        </td>
                        <td className="p-2 border-b border-r border-gray-200">
                            {at.Link && (
                                <div className="mb-2 p-2 bg-red-50 border border-red-200 rounded">
                                    
                                    {/* Youtube Preview */}
                                    {(at.Link.includes('youtube.com') || at.Link.includes('youtu.be')) && (
                                        <iframe
                                            className="w-full h-44 rounded"
                                            src={getYoutubeEmbedUrl(at.Link)}
                                            title="youtube-video"
                                            allowFullScreen
                                        />
                                    )}

                                    <button
                                        type="button"
                                        onClick={() => window.open(at.Link, '_blank')}
                                        className="mt-2 text-red-700 font-bold hover:underline"
                                    >
                                        Open Link
                                    </button>
                                </div>
                            )}
                            {at.existingFileName && (
                                <div className="mb-2 p-1.5 bg-blue-50 border border-blue-100 rounded flex justify-between items-center font-semibold">
                                    <button
                                        type="button"
                                        onClick={() => openSavedFileSecurely(at.existingFileName)}
                                        className="text-blue-700 hover:underline truncate max-w-[280px] text-left font-bold bg-transparent border-0 p-0 cursor-pointer"
                                    >
                                        {String(at.existingFileName).split('/').pop() || "View File"}
                                    </button>
                                    <span 
                                        onClick={() => openSavedFileSecurely(at.existingFileName)}
                                        className="text-[9px] bg-blue-200 text-blue-800 px-1.5 py-0.5 rounded font-bold cursor-pointer hover:bg-blue-300"
                                    >
                                        SAVED
                                    </span>
                                </div>
                            )}

                            {at.studyType === 'External Link' ? (
                                <div className="space-y-2">

                                    <input
                                        type="text"
                                        value={at.Link || ''}
                                        placeholder="Enter YouTube URL"
                                        className="w-full p-2 border border-gray-200 rounded outline-none font-medium text-blue-600"
                                        onChange={(e) => {
                                            const value = e.target.value;

                                            setAttachments((prev) =>
                                                prev.map((item, i) =>
                                                    i === index
                                                        ? { ...item, Link: value }
                                                        : item
                                                )
                                            );
                                        }}
                                    />

                                    {at.Link &&
                                        (at.Link.includes('youtube.com') ||
                                        at.Link.includes('youtu.be')) && (
                                            <iframe
                                                className="w-full h-44 rounded"
                                                src={getYoutubeEmbedUrl(at.Link)}
                                                title="youtube-video"
                                                allowFullScreen
                                            />
                                    )}

                                    {at.Link && (
                                        <button
                                            type="button"
                                            onClick={() => window.open(at.Link, '_blank')}
                                            className="text-red-700 font-bold hover:underline"
                                        >
                                            Open Link
                                        </button>
                                    )}
                                </div>
                            ) : (
                                <input type="file" className="text-xs w-full cursor-pointer file:mr-3 file:py-1 file:px-2 file:rounded file:border-0 file:text-xs file:font-bold file:bg-gray-100 file:text-gray-700 hover:file:bg-gray-200" 
                                    accept={
                                        at.studyType === 'Image' ? 'image/*' : 
                                        at.studyType === 'Video' ? 'video/mp4,video/mkv' : 
                                        '.pdf,.doc,.docx,.xls,.xlsx'
                                    }
                                    onChange={(e) => handleFileChangeAndUpload(index, e.target.files[0], at.studyType)} 
                                />
                            )}
                        </td>
                        <td className="p-2 border-b border-gray-200 text-center">
                            <FaTrash className="text-gray-300 hover:text-red-600 cursor-pointer text-sm mx-auto" onClick={() => removeRow(index)} />
                        </td>
                    </tr>
                    ))}
                    
                </tbody>
                </table>
                </div>
                <div className="md:hidden space-y-4">

                    {attachments.map((at, index) => (

                        <div
                            key={index}
                            className="border rounded-xl bg-gray-50 shadow-sm p-4 space-y-4"
                        >

                            {/* Description */}
                            <div>
                                <label className="block text-xs font-bold mb-1">
                                    Description
                                </label>

                                <input
                                    type="text"
                                    value={at.filedescription}
                                    className="w-full border rounded-lg p-2"
                                    onChange={(e) => {
                                        const newAt = [...attachments];
                                        newAt[index].filedescription = e.target.value;
                                        setAttachments(newAt);
                                    }}
                                />
                            </div>

                            {/* Type */}
                            <div>
                                <label className="block text-xs font-bold mb-1">
                                    Type
                                </label>

                                <select
                                    value={at.studyType}
                                    className="w-full border rounded-lg p-2"
                                    onChange={(e) => {
                                        const newAt = [...attachments];
                                        newAt[index].studyType = e.target.value;
                                        setAttachments(newAt);
                                    }}
                                >
                                    <option value="Document">Document</option>
                                    <option value="Image">Image</option>
                                    <option value="Video">Video</option>
                                    <option value="External Link">External Link</option>
                                </select>
                            </div>

                            {/* File */}
                            <div>

                                {
                                    at.studyType === "External Link"

                                    ?

                                    <input
                                        type="text"
                                        value={at.Link || ""}
                                        className="w-full border rounded-lg p-2"
                                        placeholder="Enter YouTube URL"
                                        onChange={(e) => {
                                            const value = e.target.value;

                                            setAttachments(prev =>
                                                prev.map((item, i) =>
                                                    i === index
                                                        ? { ...item, Link: value }
                                                        : item
                                                )
                                            );
                                        }}
                                    />

                                    :

                                    <input
                                        type="file"
                                        className="w-full"
                                        onChange={(e) =>
                                            handleFileChangeAndUpload(
                                                index,
                                                e.target.files[0],
                                                at.studyType
                                            )
                                        }
                                    />

                                }

                            </div>

                            {/* Saved File */}

                            {at.existingFileName && (

                                <button
                                    type="button"
                                    onClick={() =>
                                        openSavedFileSecurely(
                                            at.existingFileName
                                        )
                                    }
                                    className="text-blue-600 underline text-sm"
                                >
                                    View Uploaded File
                                </button>

                            )}

                            {/* Delete */}

                            <div className="flex justify-end">

                                <FaTrash
                                    className="text-red-600 cursor-pointer"
                                    onClick={() => removeRow(index)}
                                />

                            </div>

                        </div>

                    ))}

                </div>
                {/* </div> */}
                {attachments.length === 0 && <div className="p-10 text-center text-gray-400 text-xs italic bg-gray-50 border border-t-0 rounded-b">0 Attachment's found.</div>}
            </div>

            <div className="p-6 border-t bg-gray-50 flex justify-center flex-shrink-0">
                <button onClick={handleSave} className="bg-[#337ab7] hover:bg-[#20507a] text-white w-full py-3 rounded font-bold uppercase text-sm tracking-wider">
                    {isEditing ? 'UPDATE DETAILS' : 'SAVE DETAILS'}
                </button>
            </div>
            </div>
            </div>
        </div>
      )}
    </div>
  );
};

export default AddvideoStudyMaterial;